import { Button, Stack } from "@mui/material";
import * as React from "react";
import {
    EditModes,
    useTemplateViewEdit,
} from "src/components/providers/template-view-edit-provider";
import QueueIcon from "@mui/icons-material/Queue";
import styled from "styled-components";

const AddButton = styled(Button)`
    width: 100%;
    &:hover {
        border: 1px dashed;
    }
`;
const TemplateAdd = ({ templateIndex }: { templateIndex: number }) => {
    const { editView } = useTemplateViewEdit();

    const handleClick = () => {
        if (editView) {
            editView({
                templateIndex,
                editMode: EditModes.addTemplate,
            });
        }
    };

    return (
        <Stack alignItems="center" justifyContent="center" direction="row">
            <AddButton
                color="secondary"
                startIcon={<QueueIcon />}
                onClick={handleClick}
                aria-label="add section"
            >
                Add Section
            </AddButton>
        </Stack>
    );
};

export default TemplateAdd;
